import { render, staticRenderFns } from "./PageRegister.vue?vue&type=template&id=770c1d68&scoped=true&"
import script from "./PageRegister.vue?vue&type=script&lang=ts&"
export * from "./PageRegister.vue?vue&type=script&lang=ts&"
import style0 from "./PageRegister.vue?vue&type=style&index=0&id=770c1d68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770c1d68",
  null
  
)

export default component.exports